import { render, staticRenderFns } from "./ViewCourse.vue?vue&type=template&id=0cf6b862"
import script from "./ViewCourse.vue?vue&type=script&lang=js"
export * from "./ViewCourse.vue?vue&type=script&lang=js"
import style0 from "./ViewCourse.vue?vue&type=style&index=0&id=0cf6b862&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports